
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConfig, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';

const authConfig: AuthConfig = {
  issuer: "https://accounts.google.com",
  strictDiscoveryDocumentValidation: false,
  clientId: "68528419432-mb4ovgbbfah7g5o46fmj3a5et1q26odv.apps.googleusercontent.com",
  redirectUri: window.location.origin + "/public/verification",
  scope: "openid profile email",
  // 🆕 F2-385: Authorization Code + PKCE en vez de Implicit. El id/access_token ya NO
  // viaja en la URL (solo un `code` opaco), lo que evita el heurístico de "phishing" de
  // Safe Browsing (confirmado: la pantalla roja marcaba .../verification#access_token=ya29...).
  // El canje del code lo hace el BACKEND (/auth/client-code), porque Google exige clientSecret.
  responseType: "code",
  //showDebugInformation: true,
}

@Injectable({
  providedIn: 'root',
})
export class AuthGoogleService {

  constructor(private oauthService: OAuthService,
    private _router: Router,
    private storage: OAuthStorage,
  ) {
    this.oauthService.configure(authConfig);
    // Solo cargamos el discovery; NO tryLogin: el canje del authorization code lo hace
    // el backend (/auth/client-code), no la librería.
    this.oauthService.loadDiscoveryDocument();
  }

  initLogin() {
    // Inicia el flujo Authorization Code + PKCE (redirige a accounts.google.com).
    this.oauthService.initCodeFlow();
  }

  /**
   * 🆕 F2-385: parámetros para el canje server-side tras el redirect de Google.
   * `code` viene en el query string; `codeVerifier` (PKCE) lo guardó la librería en el
   * OAuthStorage (clave 'PKCE_verifier') al iniciar el flujo.
   */
  getGoogleCodeParams(): { code: string | null; codeVerifier: string | null; redirectUri: string } {
    const params = new URLSearchParams(window.location.search);
    return {
      code: params.get('code'),
      codeVerifier: this.storage.getItem('PKCE_verifier'),
      redirectUri: authConfig.redirectUri as string,
    };
  }

  logout() {
    try {
      if (this.isTokenValid()) {
        // Revoca el token y cierra sesión
        this.oauthService.revokeTokenAndLogout();
      }
    } catch (e) { }
    this.clearLocalStorage();
    this._router.navigate(['/']);
  }

  clearLocalStorage() {
    // Limpia cualquier dato relacionado con la autenticación del almacenamiento local
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('id_token');
  }

  async getToken() {
    // Obtiene el ID token actual
    return this.oauthService.getIdToken();
  }

  private isTokenValid(): boolean {
    const accessToken = this.oauthService.getAccessToken();
    return !!accessToken && this.oauthService.hasValidAccessToken();
  }

}